import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import AreaActionTypes from 'web-app/react/entities/areas/action-types';

import ActionTypes from './action-types';

const AddAreaModal = Record({
    isVisible: false,
    areaId: undefined,
    institutions: List(),
    submitting: false,
});

export default handleActions(
    {
        [ActionTypes.ADD_AREA_MODAL_SHOW]: (state, {payload}) => {
            return state.merge({
                isVisible: true,
                submitting: false,
                areaId: payload.areaId,
                institutions: payload.institutions,
            });
        },

        [ActionTypes.ADD_AREA_MODAL_HIDE]: () => new AddAreaModal(),

        [AreaActionTypes.AREA_ADD_INSTITUTION]: state =>
            state.merge({
                submitting: true,
            }),

        [AreaActionTypes.AREA_ADD_INSTITUTION_FAILED]: state =>
            state.merge({
                submitting: false,
            }),
        [AreaActionTypes.AREA_ADD_INSTITUTION_SUCCESS]: () => new AddAreaModal(),
    },
    new AddAreaModal(),
);
